(ns minorodata.connections.sources.mysql-binlog
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "mysql-binlog"
   :name         "MySQL Binary Log"
   :description  "The world's most popular open source database. Connection to Binary Log"
   :image-source "mysql.png"
   :tags         ["data-import"]
   :enabled      false

   :preview-formatter
   (fn [source]
     (str "DB: "
          (get-in source [:source-db-creds :dbname])
          ", server: "
          (get-in source [:source-db-creds :host])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [port user password extra dbname hostname name description
                    bastion-hostname bastion-user bastion-password use-ssl require-ssl
                    has-bastion?]} data]
        {:source-type "mysql-binlog"
         :name        name
         :description description

         :source
         (cond-> {:source-db-creds {:dbtype     "mysql"
                                    :host       hostname
                                    :port       port
                                    :user       user
                                    :password   password
                                    :extra      extra
                                    :dbname     dbname
                                    :useSSL     use-ssl
                                    :requireSSL require-ssl}}

           (and has-bastion?
                (every? some? [bastion-hostname
                               bastion-user
                               bastion-password]))
           (assoc :bastion {:host     bastion-hostname
                            :user     bastion-user
                            :password bastion-password
                            :db-host  hostname}))}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [source-db-creds bastion]} source
            {:keys [host user password db-host]} bastion

            source-host  (:host source-db-creds)
            use-ssl      (:useSSL source-db-creds)
            require-ssl  (:requireSSL source-db-creds)

            has-bastion? (if (every? some? [host user password])
                           true
                           false)]
        (merge (select-keys source-db-creds [:port :user :password :extra :dbname])
               {:bastion-hostname host
                :bastion-user     user
                :bastion-password password
                :hostname         (or db-host source-host)
                :name             name
                :description      description
                :has-bastion?     has-bastion?
                :use-ssl          use-ssl
                :require-ssl      require-ssl})))

    :validate (constantly nil)

    :id :mysql-binlog-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Hostname"
              :name       :hostname
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Port"
              :name       :port
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Database User"
              :name       :user
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Database Password"
              :name       :password
              :type       :password
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Database Name"
              :name       :dbname
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Extra Parameters"
              :name       :extra
              :value      ""}

             {:block-type :checkbox
              :label      "Use SSL"
              :name       :use-ssl
              :type       :checkbox
              :value      false}

             {:block-type :checkbox
              :label      "Require SSL"
              :name       :require-ssl
              :type       :checkbox
              :value      false}

             {:block-type :checkbox
              :label      "Requires tunneling"
              :name       :has-bastion?
              :type       :checkbox
              :value      false}

             {:block-type :subtitle
              :content    "Bastion host"
              :conditions [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion Hostname"
              :name          :bastion-hostname
              :required      true
              :value         ""
              :default-value ""
              :conditions [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion User"
              :name          :bastion-user
              :value         ""
              :default-value ""
              :required      true
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion Password"
              :name          :bastion-password
              :value         ""
              :default-value ""
              :type          :password
              :required      true
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type :submit
              :content    "SAVE"}]}



   :extract-form
   {:format-for-api
    (fn [{:keys [name description status
                 source-schema source-table columns
                 update-column extract-type
                 destination-table action]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [(app.utils/keep-non-nil-keys
                    {:action            action
                     :source-table      (str source-schema "." source-table)
                     :extract-type      extract-type
                     :destination-table destination-table
                     :columns           columns
                     :update-column     (when (= "incremental" extract-type)
                                          update-column)})]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config source-id]} data

            extract (get-in config [:extracts 0])

            {:keys [columns source-table]} extract

            [_ schema table] (re-matches #"(.*?)\.(.*)" (or source-table ""))]

        (merge
         (select-keys extract [:action :destination-table :extract-type :update-column])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :source-id     source-id

           :source-schema schema
           :source-table  table

           :columns (if (some? columns)
                      columns
                      [])}))))

    :validate (constantly nil)

    :id :mysql-binlog-extract-form

    :blocks [{:block-type :subtitle
              :content    "In development..."}]}})
